module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-sl.538a3026.png";